<!-- Accessory.vue -->
<template>
	<div class="recommend-wrapper">
		<div class="ui-commmon-header">
			<img src="../../assets/image/change-icon/back@2x.png" v-on:click='goBack()' class="ui-go-back">
			<h3>组合优惠</h3>
			<img src="../../assets/image/change-icon/b2_cart@2x.png" class="ui-cart" v-on:click='goCart()'>
			<span class="cart-number" v-if="cartNumber <= 100 && cartNumber > 0">{{ cartNumber }}</span>
			<span class="cart-number" v-if="cartNumber >= 100  && cartNumber > 0">99+</span>
		</div>
		<div class="ui-recommend-body" v-infinite-scroll="getMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
			<div  v-if="detailInfo && detailInfo.zhpromos && detailInfo.zhpromos.length > 0"  v-for="(zhpromos, i) in detailInfo.zhpromos" >
				<div style="margin-top:6px;-webkit-box-flex: 1;height: 44px;font-size: 16px;color: #FFFFFF;text-align: center;line-height: 44px;cursor: pointer;">
					<div style="background:#4caf50">{{zhpromos.name}}</div>
				</div>
				<v-recommend-list  style="padding-left:8vw;" v-for="(item, index) in zhpromos.goods_list" :item="item" :productId="item.id" v-bind:key="index"></v-recommend-list>
				<div style=" -webkit-box-flex: 1;height: 44px;font-size: 16px;color: #FFFFFF;text-align: center;line-height: 44px;">
					<div style="height:44px;float:left;font-size:4vw;width:60vw;background: #FA800A;">礼包价:￥{{zhpromos.package_price}} <span style="margin-left: 4px;font-size: 2vw;">节省:￥{{zhpromos.saving}}</span></div>
					<div @click="addCart(zhpromos)" style="float:left;width: 40vw;background: #F40000;cursor: pointer;">加入购物车</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { productAccessoryList } from '../../api/product';
	import { cartQuantity,packageCart } from '../../api/cart';
	import combinationPromotionBody from '../product-detail/child/CombinationPromotionBody';
	import { mapState, mapMutations } from 'vuex';
	import { Indicator, Toast, MessageBox } from 'mint-ui';
	export default {
		data() {
			return {
				recommendList: [],
				listParams: {
                	"page": 0,
                	"per_page": 10
				},
				loading: false,
				isMore: true,
				quantity: 0
			}
		},

		components: {
			'v-recommend-list': combinationPromotionBody
		},

		created(){
			this.$on('get-cart-quantity', () => {
				this.getCarNumber();
			})
		},

		computed: mapState({
			user: state => state.auth.user,
			cartNumber: state => state.tabBar.cartNumber,
			detailInfo: state => state.detail.detailInfo
		}),
		methods: {
			...mapMutations({
				setCartNumber: 'setCartNumber',
			}),
			/*
			 *  getCarNumber: 获取购物车数量
			 */
			getCarNumber() {
				cartQuantity().then(res => {
					if (res) {
						this.setCartNumber(res.quantity);
					}
				})
			},
			addCart(zhpromos){
				packageCart({package_id:zhpromos.id,number:1}).then(response => {
					this.getCarNumber()
					Toast('加入购物车成功!');
        },
        error => {
          Toast('请求异常:'+error.errorMsg);
        }
      )

			},
			/*
				goBack: 返回到上一页
			 */
			goBack() {
				this.$router.go(-1);
			},

			/*
			 *  goCart: 跳转到购物车
			 */
			goCart() {
				if (this.user) {
					this.$router.push({'name': 'cart', 'params': {type: 0}});
				} else {
					this.$router.push({'name': 'signin'});
				}
			}
		}
	}
</script>

<style lang='scss' scoped>
.recommend-wrapper {
	background-color: #ffffff;
	.ui-commmon-header {
		border-bottom: 1px solid #E8EAED;
		background-color: #ffffff;
		width: -webkit-fill-available;
	    height: auto;
	    min-height: 44px;
	    position: absolute;
		span.cart-number {
			top: 5px;
			right: 15px;
			min-width: 18px;
			min-height: 14px;
			line-height: 14px;
		}
		img.ui-cart {
			width: 30px;
			height: 30px;
		}
	}
	.ui-recommend-body {
		background-color: #ffffff;
		width: 100%;
		position: absolute;
	    top: 45px;
	    bottom: 0px;
	    width: 100%;
	    height: auto;
		overflow: auto;
	}
	.recommend-no-more {
		color: #7C7F88;
		font-size: 12px;
		padding: 0px;
		margin: 0px;
		text-align: center;
    	padding: 10px 0px;
	}
}
</style>



// WEBPACK FOOTER //
// src/page/product-detail/CombinationPromotionList.vue